module.exports = __webpack_public_path__ + "static/media/S3N2-3.78eefb24.svg";